import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useSite } from "../context/SiteContext";
import { ExcursionCard } from "../components/ExcursionCard";
import { photoUrl } from "../lib/api";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

const headlines = {
  spring: { ru: ["Весна", "на Алтае"], en: ["Spring", "in Altai"] },
  summer: { ru: ["Лето", "без границ"], en: ["Summer", "without limits"] },
  autumn: { ru: ["Золотой", "Алтай"], en: ["Golden", "Altai"] },
  winter: { ru: ["Тишина", "Алтая"], en: ["The silence", "of Altai"] },
};

export default function SeasonPage() {
  const { season } = useParams();
  const { t, lang } = useLang();
  const site = useSite();
  const [excursions, setExcursions] = useState([]);

  useEffect(() => {
    api.get(`/excursions?season=${season}`).then((r) => setExcursions(r.data)).catch(() => {});
  }, [season]);

  const sp = site?.seasons?.[season] || {};
  const hl = headlines[season] || { ru: [sp.name_ru || ""], en: [sp.name_en || ""] };

  return (
    <div data-testid={`season-page-${season}`} style={{ background: "#F4F0E7" }}>
      <Seo
        path={`/seasons/${season}`}
        lang={lang}
        title={`${lang === "ru" ? sp.name_ru : sp.name_en || ""} · ${lang === "ru" ? "Алтай" : "Altai"}`}
        description={lang === "ru" ? sp.tagline_ru : sp.tagline_en}
        image={photoUrl(sp.hero_photo_id)}
      />
      <section className="relative grain overflow-hidden" style={{ height: "80svh" }}>
        <motion.img initial={{ scale: 1.12 }} animate={{ scale: 1 }} transition={{ duration: 2.2 }} src={photoUrl(sp.hero_photo_id)} alt={sp.name_ru} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(17,17,15,0.4), rgba(17,17,15,0.85))" }} />
        <div className="relative h-full max-w-[1600px] mx-auto px-5 md:px-10 flex flex-col justify-end pb-16">
          <Reveal>
            <p className="eyebrow mb-4">{t("nav_seasons")}</p>
            <h1 className="display display-xl text-argali-ivory">{(lang === "ru" ? hl.ru : hl.en).map((l, i) => <span key={i} className="block">{l}</span>)}</h1>
            <p className="text-argali-ivory/80 mt-6 max-w-lg">{lang === "ru" ? sp.tagline_ru : sp.tagline_en}</p>
          </Reveal>
        </div>
      </section>

      <section className="px-5 md:px-10 py-24">
        <div className="max-w-[1600px] mx-auto">
          <p className="eyebrow mb-10" style={{ color: "#A96818" }}>{excursions.length} {t("routes_count")}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {excursions.map((e, i) => <ExcursionCard key={e.id} exc={e} index={i} />)}
          </div>
        </div>
      </section>
    </div>
  );
}
